/*=========================================================================================
  File Name: module-invoicefiles-getters.js
  Description: InvoiceFiles Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {};
